export default __webpack_public_path__ + "static/media/monitor-do-sistema-1600x900.91289a47.png";